

















































































import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
import PasswordVerificationRules from '@/components/PasswordVerificationRules.vue'
export default Vue.extend({
    components: { PasswordVerificationRules, VueRecaptcha },
    props: {
        //  Determines if pre-existing values are disabled (used when a user is already authenticated)
        dirty: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        //  The user being registered
        registrationUser: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            //  A list of disabled components, used when the 'Dirty' prop is set
            disabled: [],
            //  Styles for our elements at the foot of the page
            footerStyle: {
                position: 'absolute',
                left: 0,
                right: 0,
                margin: 'auto',
                display: 'block'
            },
            //  V-model for user's mobilephone, used for validation purposes
            mobilephone: null,
            //  show password
            showPassword: false,
            //  Terms checkbox bool
            terms: false,
            // The submission state, used for recaptcha
            submitting: false,
            // The recaptcha key
            recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY
        }
    },
    mounted() {
        //  If the dirty prop is set, we disabled fields already set
        if (this.dirty) this.disableExisting()

        //  If the user has a mobilephone, set detached v-model mobilephone
        if (this.registrationUser.mobilephone)
            this.mobilephone = this.$options.filters.phone(
                this.registrationUser.mobilephone
            )

        //  If the user has accept term, set detached v-model term
        if (this.registrationUser.terms_accepted) this.terms = true
    },
    computed: {
        ...mapGetters([
            'isApp',
            'recaptchaVerifiedTime',
            'recaptchaVerified',
            'showRecaptcha'
        ]),
        linkTarget(): string {
            //  If we are on app, use system, else use blank
            return this.isApp ? '_system' : '_blank'
        },
        termsLink(): string {
            return `${process.env.VUE_APP_URL_SITE}/terms`
        }
    },
    methods: {
        attachSelectedFields(): void {
            //  Default the first tenant name to the organization's name
            this.registrationUser.selected_company_name = this.registrationUser.email
            this.registrationUser.organization_name = this.registrationUser.email
        },
        disableExisting(): void {
            //  For each key => value in the user
            for (const [key, value] of Object.entries(this.registrationUser)) {
                //  If the value exists, add the key to the disabled list
                if (value) this.disabled.push(key)
            }
        },
        getUserDevice(user) {
            //  If we're on a mobile browser, return 'Mobile Browser'
            if (this.$store.getters.isMobile) return 'Mobile Browser'

            //  Else, if we're running the native mobile application, return 'Mobile App'
            if (this.$store.getters.isNativeApp) return 'Mobile App'

            //  Else, return 'Desktop'
            return 'Desktop'
        },
        getUserProfinder(user): string {
            //  If the user is a qbo_user, return 'QBO'
            if (user.qbo_user) return 'QBO'

            //  Else, if the user has a xero id, return 'XERO'
            if (user.xero_id || user.xero_id_tmp) return 'XERO'

            //  Else, return empty string
            return ''
        },
        goToLogin(): void {
            this.$router.push('/signin')
        },
        hasErrors(name: string) {
            //  Check for existing validation errors
            const hasErrors = this.errors.collect(name).length > 0

            //  If the field has errors, return true
            if (hasErrors) return true
        },
        async onCaptchaVerified(token: string): Promise<void> {
            // Set the submission flag to true to disable the submit button
            this.submitting = true

            // Reset the reCAPTCHA widget
            this.$refs.recaptcha.reset()

            // Verify the reCAPTCHA token
            const success = await this.$store.dispatch('verifyRecaptcha', token)

            // If NOT successful (reCAPTCHA thinks user is a bot), pop the challenge
            if (!success) this.$refs.recaptcha.execute()

            // Set the submission flag to true to enable the submit button
            this.submitting = false

            // If successful (reCAPTCHA thinks user is human), submit
            this.submit()
        },
        onCaptchaExpired(): void {
            // Reset the reCAPTCHA widget
            this.$refs.recaptcha.reset()
        },
        popMobilePhoneInfo(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Mobile Phone',
                text: 'This should be a mobile phone number not your buisness number. This is purely used for Two Factor Authentication purposes to help protect your account.',
                icon: 'bi-question-circle-fill',
                color: 'primary',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        },
        popRecaptcha() {
            //  If 'recaptcha' is disabled, do nothing
            if (!this.showRecaptcha) return

            //  Else, check if the user is already verified
            const isVerified =
                this.recaptchaVerified &&
                Number(new Date()) - this.recaptchaVerifiedTime > 120000

            //  If the user is already verified, we skip recaptcha
            if (isVerified) return

            //  Else, pop recaptcha challenge
            this.$refs.recaptcha.execute()
        },
        scopedName(name: string): string {
            //  Check if disabled includes this name
            const included = this.disabled.includes(name)

            //  If it does just return our name
            if (included) return name

            //  Else, prepend 'required'
            return `required.${name}`
        },
        async submit(): Promise<void> {
            //  Check if the form is valid (validate only the required scopes)
            const valid = await this.$validator.validateAll('required')

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Else, Parse the selected_company_name
            this.attachSelectedFields()

            //  Get the user's provider (if it exists)
            const provider = this.getUserProfinder(this.registrationUser)
            this.registrationUser.type = provider

            //  Get the user device
            const device = this.getUserDevice(this.registrationUser)
            this.registrationUser.type = device

            // If not recaptcha verified or last verification was over two minutes ago, verify recaptcha token

            //  Pop recaptcha
            this.popRecaptcha()

            //  Emit valid user to parent component
            this.$emit('submit', this.registrationUser)
        }
    }
})
